import { Injectable } from '@angular/core';

// Rx JS imports
import { Observable } from 'rxjs';

// Models
import { ProductPage } from '../models/product.page';

@Injectable({ providedIn: 'root' })
export class ProductPageService {

    constructor() { }

    public watchProductPage(key: string): Observable<ProductPage> {
        return new Observable(subscriber => {
            let tourPage: ProductPage = productPages.find(tour => tour.key == key);
            if(!tourPage) subscriber.error('cannot find tour');
            subscriber.next(tourPage);
        });
    }

    public watchAllProductPages(): Observable<ProductPage[]> {
        return new Observable(subscriber => {
            subscriber.next(productPages);
        });
    }
}

// Temp solution before db connection 
export const productPages: ProductPage[] = [
    new ProductPage('folkets-kvinde', {
        title: 'Folkets Kvinde m. Frokost',
        subTitle: 'Vil du med på eventyr i Hillerød og høre om en særlig kvinde?',
        language: 'da',
        productKey: '-MF_F5wKBZ8icisdIQSu',
        price: 249,
        media: {
            hd: 'assets/frederiksborg-slot.jpg',
            type: 'IMAGE'
        },
        sections: [{
            title: 'Folkets Kvinde',
            paragraphs: ['Vil du med på eventyr i Hillerød og høre om en særlig kvinde?'],
            align: 'center',
            cta: 'Se Trailer',
            ctaType: 'trailer',
            media: {
                hd: 'assets/frederiksborg-slot.jpg',
                video: 'assets/folkets-kvinde.mp4',
                type: 'VIDEO'
            },
            backgroundType: 'image'
        }, {
            title: 'En Glemt Fortælling',
            paragraphs: ['Der var engang en kvinde ved navn Louise, som kom fra fattige kår i 1800-tallets København. I kraft af menneskelig indsigt, viljestyrke og gåpåmod kæmpede hun sig til toppen af det danske samfund.', 'Louise blev tildelt titlen Grevinde Danner, men hun glemte aldrig hvor hun kom fra. Gennem hendes nyfundne plads nær Kongen af Danmark, spillede hun en afgørende rolle i indførelsen af den danske grundlov.', 'Når du er klar til at tage del i eventyret, venter Louise på dig i Hillerød sammen med din virtuelle guide, Lars. Sammen vil de fortælle historien om Folkets Kvinde omkring det prægtige Frederiksborg Slot. '],
            media: {
                hd: 'assets/danner.jpg'
            }
        }, {
            title: 'Hvordan virker det?',
            paragraphs: ['Vores web app bruger din lokation til at guide dig gennem en dags eventyr omkring Frederiksborg Slot.', 'Når du er 20 meter fra et punkt, kan du låse op for det, og få fortalt historien om netop dét sted. ', 'Undervejs er der indlagt en lækker frokost på Cafe Havehuset til en god pris. '],
            icons: ['location', 'route', 'restaurant'],
            type: 'icon',
            align: 'right',
            media: {
                hd: 'assets/how-it-works-hillerød.png',
                type: 'IMAGE'
            }
        }, {
            title: 'Hvad skal jeg have med?',
            paragraphs: ['En opladt smartphone.', 'Hovedtelefoner.', 'En halv dag til at gennemføre turen (tre-fire timer eksklusiv eventuel transport til og fra Hillerød).', 'Godt selskab er anbefalet.'],
            icons: ['location', 'headphones', 'clock', 'user', 'price'],
            media: {
                hd: 'assets/what-to-bring.png',
                type: 'IMAGE'
            },
            type: 'icon'
        }, {
            title: 'Frokost på Cafe Havehuset',
            media: {
                video: 'assets/folkets-kvinde.mp4',
                type: 'VIDEO',
                hd: 'assets/havehuset.jpg'
            },
            backgroundType: 'none',
            paragraphs: ['Når du køber Folkets Kvinde, kan du tilkøbe en frokostpakke til en god pris. Herligheden nydes i smukke omgivelser på Cafe Havehuset, som er et indlagt stop på turen. '],
            mediaArray: [
                { hd: 'assets/frokost.jpg', description: 'Din frokost starter med to stykker klassisk dansk smørrebrød.' },
                { hd: 'assets/oel.jpg', description: 'Med frokosten får du en valgfri sodavand, en fadøl eller et glas vin.' },
                { hd: 'assets/kage.jpg', description: 'Måltidet afsluttes med et stykke af dagens kage. ' },
                { hd: 'assets/kaffe.webp', description: 'Nyd kaffe og te ad libitum på cafeen. ' },
                { hd: 'assets/havehuset.jpg', description: 'Støt et godt formål; Havehuset er en socialøkonomisk cafe.' }],
            align: 'center',
            cta: 'Se video om Cafe Havehuset',
            ctaType: 'trailer'
        }, {
            title: 'Køb Tur',
            type: 'icon',
            paragraphs: [
                "1. Køb adgang til Folkets Kvinde herunder. Adgang kan bruges af en person.", // samt frokost undervejs.
                "2. Hvis du køber mere end en tur, kan du dele med venner efter køb.",
                "3. Oplev Folkets Kvinde gennem browseren på din telefon – du behøver ikke at hente en app."
            ],
            icons: ['location', 'email', 'location'],
            cta: 'Køb Tur',
            ctaType: 'buy',
            align: 'center',
            backgroundType: 'video',
            media: {
                hd: 'assets/forest-bg.png',
                video: 'assets/forest-loop.mp4',
                type: 'VIDEO'
            }
        }]
    }),
    new ProductPage('ghostwalk', {
        title: 'Ghostwalk',
        subTitle: 'Are you ready to unlock the darkest secrets of Copenhagen?',
        language: 'en',
        price: 39,
        productKey: '-MFVq06htJsp9AHGTdzX',
        media: {
            type: 'IMAGE',
            hd: 'assets/copenhagen.jpg'
        },
        sections: [{
            title: 'Ghostwalk',
            paragraphs: ['Are you ready to unlock the darkest secrets of Copenhagen?'],
            align: 'center',
            cta: 'Watch Trailer',
            media: {
                video: 'assets/GW-main.mp4',
                type: 'IMAGE',
                hd: 'assets/copenhagen.jpg'
            }
        }, {
            title: 'Do you believe in ghosts?',
            paragraphs: ['Through a captivating storyline you will experience the macabre side of a city that is more than a thousand years old.', 'To unlock the stories, you have to be close, ensuring just the right setting all the way.', 'Once you are ready to reveal the ghosts of Copenhagen, you can meet your virtual guide, Allison, at the Round Tower.'],
            media: {
                hd: 'assets/allison.png'
            }
        }, {
            title: 'How does it work?',
            paragraphs: ['The web app tracks your location and guides you through the city. ', 'When you are 20 meters from a story, you can unlock it and listen to the ghost tale of that specific place. ', 'Empowered by 3D sound technology, the audio will change dynamically as you rotate with the phone in your hand. '],
            icons: ['location', 'route', 'headphones'],
            type: 'icon',
            align: 'right',
            media: {
                hd: 'assets/how-it-works.png',
                type: 'IMAGE'
            }
        }, {
            title: 'What do I need?',
            paragraphs: ['A charged smartphone.', 'A set of headphones.', 'Around 1 hour to complete the tour.', 'Good company is recommended.'],
            icons: ['location', 'headphones', 'clock', 'user', 'price'],
            media: {
                hd: 'assets/3dsound.png',
                type: 'IMAGE'
            },
            type: 'icon'
        }, {
            title: 'Sneak a Peek',
            paragraphs: ['Below, you can enjoy excerpts from the tour.'],
            mediaArray: [{ hd: 'assets/thorvaldsen.png' }, { hd: 'assets/tordenskjold.png' }, { hd: 'assets/arni.png' }, { hd: 'assets/kagen.png' }, { hd: 'assets/handmaiden.png' }],
            align: 'center'
        }, {
            title: 'Buy Tour',
            type: 'icon',
            paragraphs: ['1. Buy access to the tour below. You can try Ghostwalk as many times as you\'d like.', '2. If you buy more than one tour you can share it with your friends after purchase. ', '3. Experience Ghostwalk through the browser on your phone – no need to download an app.'],
            icons: ['location', 'email', 'location'],
            cta: 'Buy Tour',
            ctaType: 'buy',
            align: 'center',
            media: {
                hd: 'assets/copenhagen2.png',
                video: 'assets/GW-copenhagen-bg.mp4',
                type: 'VIDEO'
            }
        }]
    })
]


